import { inject, Injectable } from '@angular/core';
import {
  addDoc,
  collection,
  Firestore
} from '@angular/fire/firestore';
import RELEASE from '@mlc/release';
import { take } from 'rxjs/operators';
import { SupportTicket } from '../models/support-ticket.model';
import { AuthService } from './auth.service';
@Injectable({
  providedIn: 'root'
})
export class SupportService {
  private firestore: Firestore = inject(Firestore);
  private authService: AuthService = inject(AuthService);
  appVersion = `${RELEASE.version}-${RELEASE.build}`;
  constructor() { }

  submitTicket(ticketData: { subject: string, description: string }): Promise<void> {
    return new Promise((resolve, reject) => {
      this.authService.getLoggedInUser().pipe(take(1)).subscribe(user => {
        if (!user) {
          return reject('User not logged in');
        }

        const supportTicketsCollectionRef = collection(this.firestore, 'support-tickets');

        const newTicket: Partial<SupportTicket> = {
          userName: user.displayName,
          userEmail: user.email,
          orgCode: user.defaults.orgCode,
          title: ticketData.subject,
          description: ticketData.description,
          appVersion: this.appVersion,
          appName: 'CASEVUE_APP',
          orgName: user.defaults.orgName,
          moduleName: 'Not Specified',
          date: new Date().toISOString(),
        };

        addDoc(supportTicketsCollectionRef, newTicket)
          .then(() => resolve())
          .catch(error => reject(error));
      });
    });
  }
} 